import { useLanguage } from "@/hooks/useLanguage";
import { SEO } from "@/components/SEO";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TermsConditions = () => {
  const { t } = useLanguage();

  return (
    <>
      <SEO
        title={t("terms.title")}
        description="Terms and conditions for Shikwaru Adventures tours and services"
        keywords="terms, conditions, policy, safari tours, travel terms"
      />
      
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=2000&q=80')",
          }}
        >
          <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            {t("terms.title")}
          </h1>
        </div>
      </section>
      
      <div className="bg-background py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
            {t("terms.title")}
          </h1>

          <div className="space-y-8 text-foreground">
            {/* Section 1 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section1.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section1.content")}
              </p>
            </section>

            {/* Section 2 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section2.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section2.content")}
              </p>
            </section>

            {/* Section 3 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section3.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section3.content")}
              </p>
            </section>

            {/* Section 4 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section4.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section4.content")}
              </p>
            </section>

            {/* Section 5 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section5.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section5.content")}
              </p>
            </section>

            {/* Section 6 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section6.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section6.content")}
              </p>
            </section>

            {/* Section 7 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section7.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section7.content")}
              </p>
            </section>

            {/* Section 8 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section8.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground mb-4">
                {t("terms.section8.content")}
              </p>
              <div className="bg-secondary/50 p-4 rounded-md space-y-2 mb-4">
                <p className="text-sm">{t("terms.section8.table.row1")}</p>
                <p className="text-sm">{t("terms.section8.table.row2")}</p>
                <p className="text-sm">{t("terms.section8.table.row3")}</p>
                <p className="text-sm">{t("terms.section8.table.row4")}</p>
              </div>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section8.additional")}
              </p>
            </section>

            {/* Section 9 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section9.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section9.content")}
              </p>
            </section>

            {/* Section 10 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section10.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section10.content")}
              </p>
            </section>

            {/* Section 11 */}
            <section className="bg-card p-6 rounded-lg border border-border">
              <h2 className="text-2xl font-semibold mb-4 text-primary">
                {t("terms.section11.title")}
              </h2>
              <p className="whitespace-pre-line text-muted-foreground">
                {t("terms.section11.content")}
              </p>
            </section>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default TermsConditions;
